// frontend/src/components/common/FormField.tsx

import React from "react";
import styles from "./FormField.module.css";
import { DataField, FieldType } from "../../types/documentTypes";

interface FormFieldProps {
  field: DataField;
  onChange: (field: DataField) => void;
}

const FormField: React.FC<FormFieldProps> = ({ field, onChange }) => {
  const handleChange = (updates: Partial<DataField>) => {
    onChange({ ...field, ...updates });
  };

  return (
    <div className={styles.formField}>
      <input
        type="text"
        value={field.label}
        onChange={(e) => handleChange({ label: e.target.value })}
        placeholder="Field Label"
        className="surface-sunken"
      />

      <select
        value={field.type}
        onChange={(e) => handleChange({ type: e.target.value as FieldType })}
        className="surface-sunken"
      >
        <option value="Text">Text</option>
        <option value="Number">Number</option>
        <option value="Date">Date</option>
        <option value="Selection">Select</option>
        <option value="FreeText">Free Text</option>
      </select>

      <label className={styles.configCheckbox}>
        <input
          type="checkbox"
          checked={field.required}
          onChange={(e) => handleChange({ required: e.target.checked })}
        />
        Required
      </label>
    </div>
  );
};

export default FormField;
